module.exports = __webpack_public_path__ + "img/blue-uv-capture.837656bb.jpg";